import LockedOrderAlert from './LockedOrderAlert';

export default LockedOrderAlert;
